import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule} from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';

import { MyDatePickerModule } from 'mydatepicker';


// import { EffectsModule } from '@ngrx/effects';
// import { StoreModule } from '@ngrx/store';
// import { AppEffects } from '../app/redux/app.effects';

import { AppHttpInterceptor } from './auth/http-interceptor';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import { CommonService } from './common/services/common.service';
import { AuthService } from './auth/auth.service';

import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { MainRouterComponent } from './common/main-router/main-router.component';
import { FaqComponent } from './faq/faq.component';
import { LoaderComponent } from './common/loader/loader.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FaqService } from './faq/faq.service';
import { AboutusComponent } from './aboutus/aboutus.component';

import { ToasterComponent } from './common/toaster/toaster.component';
import { ToasterContainerComponent } from './common/toaster/toaster-container.component';
import { ToasterService } from './common/toaster/toaster.service';
import { ContactsComponent } from './contacts/contacts.component';
import { ContactsService } from './contacts/contacts.service';
import { UserAccountComponent } from './user-account/user-account.component';
import { CreditsComponent } from './credits/credits.component';
import { BlogComponent } from './common/blog/blog.component';
import { BlogSingleComponent } from './common/blog/single/blog-single.component';
import { HomeService } from './booking/booking-services/home.service';
import { DynamicPageComponent } from './common/dynamic-page/dynamic-page.component';
import { BookingDetailComponent } from './user-account/booking-detail/booking-detail.component';
import { BookingComponent } from './booking/booking.component';
import { BookingListComponent } from './user-account/booking-list/booking-list.component';
import { CoreModule } from './core/core.module';
import { DynamicSearchComponent } from './booking/dynamic-search/dynamic-search.component';
import { SearchDynamicComponent } from './common/flight-search-dynamic/search-dynamic.component';
import { PixelModule } from 'ngx-pixel';
import { PointsSliderComponent } from './booking/home/points-slider/points-slider.component';
import { VacaturesComponent } from './vacatures/vacatures.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainRouterComponent,
    FaqComponent,
    LoaderComponent,
    AboutusComponent,
    ToasterComponent,
    ToasterContainerComponent,
    ContactsComponent,
    UserAccountComponent,
    BookingDetailComponent,
    BookingListComponent,
    CreditsComponent,
    BlogComponent,      
    DynamicPageComponent,
    DynamicSearchComponent,
    SearchDynamicComponent,
    BlogSingleComponent,
    VacaturesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MyDatePickerModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    //PixelModule.forRoot({ enabled: true, pixelId: '1771404609769605'})
    // GoogleTagManagerModule.forRoot({
    //   id: 'GTM-5BH8QVB',
    //   // gtm_auth: YOUR_GTM_AUTH,
    //   // gtm_preview: YOUR_GTM_ENV
    // })
  ],
  exports:[
    DynamicSearchComponent,SearchDynamicComponent
  ],
  providers: [
    CommonService, AuthService, FaqService, ContactsService, ToasterService,HomeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
    { provide: 'googleTagManagerId', useValue: 'GTM-5BH8QVB' }],    
  bootstrap: [AppComponent]
})
export class AppModule { }

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
